/* MANAGERS REPORT */
export const SET_MANAGERS_REPORT_DATE = "SET_MANAGERS_REPORT_DATE";
/* MANAGERS REPORT */

/* QUALITY NON COHORT REPORT */
export const SET_NON_CAHORT_REPORT_DATE = "SET_NON_CAHORT_REPORT_DATE";
export const SET_TOP_MANAGEMENT_DATE = "SET_TOP_MANAGEMENT_DATE";
export const GET_QUALITY_CAMP_STATS = "GET_QUALITY_CAMP_STATS";
export const SET_QUALITY_CAMP_STATS = "SET_QUALITY_CAMP_STATS";
export const GET_QUALITY_ADGROUPS_STATS = "GET_QUALITY_ADGROUPS_STATS";
export const SET_QUALITY_ADGROUPS_STATS = "SET_QUALITY_ADGROUPS_STATS";
export const GET_QUALITY_BANNER_STATS = "GET_QUALITY_BANNER_STATS";
export const SET_QUALITY_BANNER_STATS = "SET_QUALITY_BANNER_STATS";
export const GET_QUALITY_FILTERS = "GET_QUALITY_FILTERS";
export const SET_QUALITY_FILTERS = "SET_QUALITY_FILTERS";
export const GET_QUALITY_WIDGETS = "GET_QUALITY_WIDGETS";
export const SET_QUALITY_WIDGETS = "SET_QUALITY_WIDGETS";
export const SET_QUALITY_TABLE = "SET_QUALITY_TABLE";
export const SET_QUALITY_EVENTS = "SET_QUALITY_EVENTS";
export const GET_QUALITY_MEDIA_SOURCE = "GET_QUALITY_MEDIA_SOURCE";
export const SET_QUALITY_MEDIA_SOURCE = "SET_QUALITY_MEDIA_SOURCE";
export const GET_REPORT_QUALITY_EVENTS_STATS = "GET_REPORT_QUALITY_EVENTS_STATS";
export const SET_REPORT_QUALITY_EVENTS_STATS = "SET_REPORT_QUALITY_EVENTS_STATS";
/* QUALITY NON COHORT REPORT */

/* TOP MANAGEMENT */
export const GET_TOP_MANAGEMENT_PROFIT = "GET_TOP_MANAGEMENT_PROFIT";
export const SET_TOP_MANAGEMENT_PROFIT = "SET_TOP_MANAGEMENT_PROFIT";
export const GET_TOP_MANAGEMENT_APP_PROFIT = "GET_TOP_MANAGEMENT_APP_PROFIT";
export const SET_TOP_MANAGEMENT_APP_PROFIT = "SET_TOP_MANAGEMENT_APP_PROFIT";
export const GET_REPORT_CAMPAIGNS_COUNT_BY = "GET_REPORT_CAMPAIGNS_COUNT_BY";
export const SET_REPORT_CAMPAIGNS_COUNT_BY = "SET_REPORT_CAMPAIGNS_COUNT_BY";
export const GET_TOP_MANAGEMENT_CLIENT_SPEND =
  "GET_TOP_MANAGEMENT_CLIENT_SPEND";
export const SET_TOP_MANAGEMENT_CLIENT_SPEND =
  "SET_TOP_MANAGEMENT_CLIENT_SPEND";
export const GET_TOP_MANAGEMENT_MEDIABUYER_PROFIT =
  "GET_TOP_MANAGEMENT_MEDIABUYER_PROFIT";
export const SET_TOP_MANAGEMENT_MEDIABUYER_PROFIT =
  "SET_TOP_MANAGEMENT_MEDIABUYER_PROFIT";
export const GET_TOP_MANAGEMENT_OFFER_PROFIT =
  "GET_TOP_MANAGEMENT_OFFER_PROFIT";
export const SET_TOP_MANAGEMENT_OFFER_PROFIT =
  "SET_TOP_MANAGEMENT_OFFER_PROFIT";
export const GET_TOP_MANAGEMENT_MEDIABUYER_STATS =
  "GET_TOP_MANAGEMENT_MEDIABUYER_STATS";
export const SET_TOP_MANAGEMENT_MEDIABUYER_STATS =
  "SET_TOP_MANAGEMENT_MEDIABUYER_STATS";
export const GET_TOP_MANAGEMENT_MEDIABUYER_SPEND =
  "GET_TOP_MANAGEMENT_MEDIABUYER_SPEND";
export const SET_TOP_MANAGEMENT_MEDIABUYER_SPEND =
  "SET_TOP_MANAGEMENT_MEDIABUYER_SPEND";
/* TOP MANAGEMENT */

/* PAYMENT COST INSPECTION REPORT */
export const GET_PAYMENT_COST_INSPECTION_REPORT_LIST =
  "GET_PAYMENT_COST_INSPECTION_REPORT_LIST";
export const SET_PAYMENT_COST_INSPECTION_REPORT_LIST =
  "SET_PAYMENT_COST_INSPECTION_REPORT_LIST";
export const SET_PAYMENT_COST_INSPECTION_DATE =
  "SET_PAYMENT_COST_INSPECTION_DATE";
export const GET_PAYMENT_COST_INSPECTION_REPORT_FILTERS =
  "GET_PAYMENT_COST_INSPECTION_REPORT_FILTERS";
export const SET_PAYMENT_COST_INSPECTION_REPORT_FILTERS =
  "SET_PAYMENT_COST_INSPECTION_REPORT_FILTERS";
/* PAYMENT COST INSPECTION REPORT */

/* COUNT BY */
export const GET_COUNT_BY_APP = "GET_COUNT_BY_APP";
export const SET_COUNT_BY_APP = "GET_COUNT_BY_APP";
export const GET_COUNT_BY_OFFER = "GET_COUNT_BY_OFFER";
export const SET_COUNT_BY_OFFER = "SET_COUNT_BY_OFFER";
export const GET_COUNT_BY_CLIENT = "GET_COUNT_BY_CLIENT";
export const SET_COUNT_BY_CLIENT = "SET_COUNT_BY_CLIENT";
export const GET_COUNT_BY_MEDIABUYER = "GET_COUNT_BY_MEDIABUYER";
export const SET_COUNT_BY_MEDIABUYER = "SET_COUNT_BY_MEDIABUYER";

/* COUNT BY */
export const GET_CAMPAIGNS_COUNT = "GET_CAMPAIGNS_COUNT";

/* REPORT RENT */
export const GET_REPORT_RENT_STATS = "GET_REPORT_RENT_STATS";
export const SET_REPORT_RENT_STATS = "SET_REPORT_RENT_STATS";
export const GET_REPORT_RENT_WIDGETS = "GET_REPORT_RENT_WIDGETS";
export const SET_REPORT_RENT_WIDGETS = "SET_REPORT_RENT_WIDGETS";
export const SET_REPORT_RENT_STATS_LOADER = "SET_REPORT_RENT_STATS_LOADER";
export const SET_REPORT_RENT_WIDGETS_LOADER = "SET_REPORT_RENT_WIDGETS_LOADER";

/* LOADERS */
export const SHOW_REPORT_LOADER = "SHOW_REPORT_LOADER";
export const HIDE_REPORT_LOADER = "HIDE_REPORT_LOADER";
export const SET_ERROR_REPORT_LOADER = "SET_ERROR_REPORT_LOADER";
export const SHOW_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER =
  "SHOW_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER";
export const HIDE_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER =
  "HIDE_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER";
export const SET_QUALITY_CAMP_STAT_LOADER = "SET_QUALITY_CAMP_STAT_LOADER";
export const SET_QUALITY_ADGROUPS_STAT_LOADER = "SET_QUALITY_CAMP_STAT_LOADER";
export const SET_MEDIA_SOURCE_LOADER = "SET_MEDIA_SOURCE_LOADER";

export const WIDGET_LOADER = "WIDGET_LOADER";

export const REQUEST_DATA_UPDATE = "REQUEST_DATA_UPDATE";